import {useContext} from 'react'

import Context from '@s-ui/react-context'
import CarCapabilitiesIcon from '@adv-mt/mt-svg-icons/lib/CarCapabilitiesOutline'
import CarDataIcon from '@adv-mt/mt-svg-icons/lib/CarDataOutline'
import CarEngineIcon from '@adv-mt/mt-svg-icons/lib/CarEngineOutline'
import MotorcycleDataIcon from '@adv-mt/mt-svg-icons/lib/MotorcycleData'
import MotorcycleSideIcon from '@adv-mt/mt-svg-icons/lib/MotorcycleSide'

import {useSpecifications} from './useSpecifications.js'

export const useGroups = ({body, consumption, cycle, engine}) => {
  const bodySpecs = useSpecifications({...body}).filter(Boolean)
  const consumptionSpecs = useSpecifications({...consumption}).filter(Boolean)
  const cycleSpecs = useSpecifications({...cycle}).filter(Boolean)
  const engineSpecs = useSpecifications({...engine}).filter(Boolean)

  const {domain} = useContext(Context)
  const config = domain.get('config')
  const APP_NAME = config.get('APP_NAME')
  const APP_NAME_COCHES = config.get('APP_NAME_COCHES')

  return [
    body && {
      key: `TECHNICAL_DETAILS_GROUP_BODY_${APP_NAME}`,
      value: bodySpecs,
      icon: APP_NAME === APP_NAME_COCHES ? CarDataIcon : MotorcycleDataIcon
    },
    engine && {
      key: 'TECHNICAL_DETAILS_GROUP_ENGINE',
      value: engineSpecs,
      icon: CarEngineIcon
    },
    consumption && {
      key: 'TECHNICAL_DETAILS_GROUP_CONSUMPTION',
      value: consumptionSpecs,
      icon: CarCapabilitiesIcon
    },
    cycle && {
      key: 'TECHNICAL_DETAILS_GROUP_CYCLE',
      value: cycleSpecs,
      icon: MotorcycleSideIcon
    }
  ]
}
